import React from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  useTheme,
} from '@mui/material';
import {
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  required
} from 'react-admin';
import { useFormContext, Controller } from 'react-hook-form';

const PackagesFormFields = ({ allRecyclings = [] }) => {
  const { control } = useFormContext();
  const theme = useTheme();

  return (
    <>
      {/* Name */}
      <TextInput source="name" validate={required()} fullWidth />

      {/* Dimensions */}
      <Box display="flex" gap={2} mt={2}>
        <TextInput source="height" label="Altura" validate={required()} fullWidth />
        <TextInput source="length" label="Comprimento" validate={required()} fullWidth />
        <TextInput source="width" label="Largura" validate={required()} fullWidth />
      </Box>

      {/* Description */}
      <TextInput source="description" label="Descrição" validate={required()} fullWidth multiline rows={3} />

      {/* Recyclings (checkboxes) */}
      <Controller
        name="recyclings"
        control={control}
        defaultValue={[]}
        render={({ field }) => (
          <Box mt={2}>
            <Typography variant="h6">Reciclagens disponíveis:</Typography>
            {allRecyclings.map((recycling) => (
              <FormControlLabel
                key={recycling.ID}
                control={
                  <Checkbox
                    checked={field.value.includes(recycling.ID)}
                    onChange={() => {
                      const newValue = field.value.includes(recycling.ID)
                        ? field.value.filter((r) => r !== recycling.ID)
                        : [...field.value, recycling.ID];
                      field.onChange(newValue);
                    }}
                  />
                }
                label={recycling.Name}
              />
            ))}
          </Box>
        )}
      />

      {/* Materials (editable array) */}
      <Typography variant="h6" gutterBottom>Materiais</Typography>
      <ArrayInput source="materials" label={false}>
        <SimpleFormIterator>
          <Box
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              padding: 2,
              marginBottom: 2,
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <TextInput source="" label="Material" validate={required()} fullWidth />
          </Box>
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
};

export default PackagesFormFields;
